import 'twin.macro';
import 'styled-components/macro';
import { Helmet } from 'react-helmet';

import { SplashLayout } from 'play/templates/splash-layout/SplashLayout';

export interface TrackNotFoundProps {
  teamSlug: string;
  trackSlug?: string;
}

export function TrackNotFound({ trackSlug, teamSlug }: TrackNotFoundProps) {
  return (
    <>
      <Helmet>
        <title>404 - instruqt</title>
      </Helmet>
      <SplashLayout bottomLeft="Hands-On Lab">
        <div tw="text-white text-center flex flex-1 flex-col justify-center">
          <h1 tw="text-4xl font-medium">Sorry, we can't find the track you're looking for</h1>
          {teamSlug && trackSlug && (
            <p tw="text-2xl leading-snug">
              {teamSlug} / {trackSlug}
            </p>
          )}
        </div>
      </SplashLayout>
    </>
  );
}
